import React, { useState, useEffect } from "react";
import { callAPI } from "../../../../axios";
import { Checkbox, ListItemText } from "@mui/material";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { formatHotelDisplayName } from "../../../../utils/utils";

const CommonFilter = (props) => {
  const [filters, setFilters] = useState(props.filter);
  const [userRoles, setUserRoles] = useState([]);
  const [userStatus, setUserStatus] = useState([]);
  const [hotelList, setHotelList] = useState([]);
  const [searchRole, setSearchRole] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [searchHotel, setSearchHotel] = useState("");

  const getUserRoles = () => {
    callAPI(`master?type=ROLES`, "GET").then((response) => {
      setUserRoles(response.data);
      setSearchFilterRoles(response.data);
    }).catch((error)=>console.warn(error))
  };

  const getUserStatus = () => {
    callAPI(`user/status`, "GET").then((response) => {
      setUserStatus(response.data);
      setSearchFilterStatus(response.data);
    }).catch((error)=>console.warn(error))
  };

  const getHotelList = () => {
    callAPI(`master?type=HOTELS`, "GET").then((response) => {
      setHotelList(response.data);
      setSearchFilterHotels(response.data);
    }).catch((error)=>console.warn(error))
  };

  useEffect(() => {
    getUserRoles();
    getUserStatus();
    getHotelList();
  }, []);

  const handleChangeCheckbox = (e) => {
    if (filters[e.target.id].includes(e.target.value)) {
      filters[e.target.id].splice(
        filters[e.target.id].indexOf(e.target.value),
        1
      );
      setFilters({
        ...filters,
      });
    } else {
      setFilters({
        ...filters,
        [e.target.id]: [...filters[e.target.id], e.target.value],
      });
    }
  };

  const resetFilter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFilters({
      freeText: null,
      roleSids: [],
      userStatus: [],
      hotelNames: [],
    });

    setSearchRole("");
    setSearchStatus("");
    setSearchHotel("");
    props.handleFilter(
      {
        freeText: null,
        roleSids: [],
        userStatus: [],
        hotelNames: [],
      },
      false
    );
  };

  const handleFilter = (e) => {
    e.preventDefault();
    e.stopPropagation();

    props.handleFilter(filters, true);
  };

  const [searchFilterRoles, setSearchFilterRoles] = useState();
  const [searchFilterStatus, setSearchFilterStatus] = useState();
  const [searchFilterHotels, setSearchFilterHotels] = useState();

  const roleFilter = () => {
    const data = userRoles.filter((item) =>
      item.name.toLowerCase().includes(searchRole.toLowerCase())
    );
    setSearchFilterRoles(data);
  };
  const statusFilter = () => {
    const data = userStatus.filter((item) =>
      item.status.toLowerCase().includes(searchStatus.toLowerCase())
    );
    setSearchFilterStatus(data);
  };
  const hotelFilter = () => {
    const data = hotelList.filter((item) =>
      item.name.toLowerCase().includes(searchHotel.toLowerCase())
    );
    setSearchFilterHotels(data);
  };

  useEffect(() => {
    roleFilter();
  }, [searchRole]);
  useEffect(() => {
    statusFilter();
  }, [searchStatus]);
  useEffect(() => {
    hotelFilter();
  }, [searchHotel]);

  const searchRoleHandle = (e) => {
    setSearchRole(e.target.value);
  };
  const searchStatusHandle = (e) => {
    setSearchStatus(e.target.value);
  };
  const searchHotelHandle = (e) => {
    setSearchHotel(e.target.value);
  };

  return (
    <div className="common-filter">
      <h3>Filter</h3>

      <h4>User Roles</h4>
      <div className="filter-list">
        <div className="filter-list_search">
          <input
            onChange={searchRoleHandle}
            value={searchRole}
            type="text"
            name="filterSearch"
            placeholder="User Roles"
          />
          <FontAwesomeIcon icon={faSearch} />
        </div>
        <ul>
          {searchFilterRoles?.map((userRole) => {
            return (
              <li key={userRole.sid}>
                <Checkbox
                  onChange={handleChangeCheckbox}
                  id={"roleSids"}
                  color="primary"
                  value={userRole.sid}
                  checked={filters.roleSids.includes("" + userRole.sid)}
                />
                <ListItemText id={userRole.sid} primary={userRole.name} />
              </li>
            );
          })}
        </ul>
      </div>
      <h4>User Status</h4>
      <div className="filter-list">
        <div className="filter-list_search">
          <input
            onChange={searchStatusHandle}
            value={searchStatus}
            type="text"
            name="filterSearch"
            placeholder="User Status"
          />
          <FontAwesomeIcon icon={faSearch} />
        </div>
        <ul>
          {searchFilterStatus?.map((userStatus, index) => {
            return (
              <li key={index}>
                <Checkbox
                  onChange={handleChangeCheckbox}
                  id={"userStatus"}
                  color="primary"
                  value={userStatus.status}
                  checked={filters.userStatus.includes("" + userStatus.status)}
                />
                <ListItemText id={index} primary={userStatus.status} />
              </li>
            );
          })}
        </ul>
      </div>
      <h4>Hotels</h4>
      <div className="filter-list">
        <div className="filter-list_search">
          <input
            onChange={searchHotelHandle}
            value={searchHotel}
            type="text"
            name="filterSearch"
            placeholder="Hotel search"
          />
          <FontAwesomeIcon icon={faSearch} />
        </div>
        <ul>
          {searchFilterHotels?.map((hotel, index) => {
            return (
              <li key={index}>
                <Checkbox
                  onChange={handleChangeCheckbox}
                  id={"hotelNames"}
                  color="primary"
                  value={hotel.name}
                  checked={filters.hotelNames.includes("" + hotel.name)}
                />
                <ListItemText id={index} primary={formatHotelDisplayName(hotel)} />
              </li>
            );
          })}
        </ul>
      </div>
      <div className="filter-buttons">
        <Button onClick={resetFilter} className="reset-btn">
          {" "}
          reset{" "}
        </Button>
        <Button onClick={handleFilter} className="submit-btn">
          submit{" "}
        </Button>
      </div>
    </div>
  );
};

export default CommonFilter;
